// extracted by mini-css-extract-plugin
module.exports = {"container":"CartHaveProductsAlerts_container__SAlSv","text":"CartHaveProductsAlerts_text__b76_B"};